"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragonDomTypes = exports.DRAGON_TYPE = exports.DRAGON_ID = void 0;
exports.findDragonNode = findDragonNode;
exports.handleMouseMove = handleMouseMove;
var services_1 = require("./services");
var page_state_1 = require("./state/page.state");
exports.DRAGON_ID = 'c-id';
exports.DRAGON_TYPE = 'c-type';
var SEARCH_LIMIT = 3;
exports.DragonDomTypes = {
    TAG: 'tag',
    COLLECTION: 'collection'
};
function findDragonNode(e) {
    var node = e.target;
    var count = 0;
    do {
        var key = node.getAttribute(exports.DRAGON_ID);
        if (key != null) {
            return node;
        }
        node = node.parentNode;
    } while (node.parentNode != null && count < SEARCH_LIMIT);
}
var hoverTimeout = null;
var HOVER_TIMEOUT = 100;
function handleMouseMove(e) {
    var node = findDragonNode(e);
    if (node != null) {
        var id = node.getAttribute(exports.DRAGON_ID);
        services_1.Services.Window.window.clearTimeout(hoverTimeout);
        hoverTimeout = null;
        page_state_1.CurrentState.setHoverId(id);
    }
    else if (hoverTimeout == null) {
        if (page_state_1.CurrentState.hoverId == null) {
            return;
        }
        hoverTimeout = services_1.Services.Window.window
            .setTimeout(function (_) {
            page_state_1.CurrentState.setHoverId(null);
            hoverTimeout = null;
        }, HOVER_TIMEOUT);
    }
}
//# sourceMappingURL=dom.js.map